"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operatorAccessStockpile = exports.operatorAccessHopper = exports.userOperatorAccess = exports.operatorAccessSilo = exports.defaultRoutePath = exports.isUserExternal = exports.userRoleAuth = void 0;
const auth_types_1 = require("pages/auth/auth.types");
const constants_1 = require("utils/constants");
const defaultAuth = {
    id: '',
    menu_id: '',
    view: false,
    change: false,
    submodule: '',
    apps_type: 'Web',
    module: 'Dashboard'
};
const getFromLocalStorage = {
    userData: () => {
        const strUserData = localStorage.getItem(constants_1.localStorageKey.userData);
        if (strUserData) {
            const userData = JSON.parse(strUserData);
            return userData;
        }
        return auth_types_1.initialUserProfile;
    }
};
const userRoleAuth = (authorization, menu, submenu) => {
    if (submenu) {
        const isAuthorize = authorization.find(auth => auth.apps_type === 'Web' &&
            auth.module.toLowerCase() === menu.toLowerCase() &&
            auth.submodule.toLowerCase() === submenu.toLowerCase());
        return isAuthorize ? isAuthorize : defaultAuth;
    }
    else {
        const isAuthorize = authorization.find(auth => auth.apps_type === 'Web' &&
            auth.module.toLowerCase() === menu.toLowerCase() &&
            (auth.view === true || auth.change === true));
        return isAuthorize ? isAuthorize : defaultAuth;
    }
};
exports.userRoleAuth = userRoleAuth;
const defaultRoutePath = (authorization, module) => {
    const userData = getFromLocalStorage.userData();
    // Define Sub Module for Each Menu
    const subModuleReport = constants_1.pathList.report.subModule;
    const subModuleDashboard = constants_1.pathList.dashboard.subModule;
    const subModuleMasterData = constants_1.pathList.masterData.subModule;
    const subModuleAdjustment = constants_1.pathList.adjustment.subModule;
    const subModuleUserAccess = constants_1.pathList.userAccess.subModule;
    const subModuleDailySummary = constants_1.pathList.dailySummary.subModule;
    const subModuleConfiguration = constants_1.pathList.configuration.subModule;
    const findDefault = findDefaultAuth(userData.authorization, module);
    const findAuth = userData.authorization.filter(auth => auth.apps_type === 'Web' && (auth.view || auth.change) &&
        auth.module.toLowerCase() === module.toLowerCase());
    const [isAuthorize] = findDefault.length > 0 ? findDefault : findAuth;
    const isAuthorizeDashboard = findDefault.length > 0 ?
        findDefault.find(i => i.view == true && i.submodule !== '') :
        findAuth.find(i => i.view == true && i.submodule !== '');
    if ((isAuthorizeDashboard === null || isAuthorizeDashboard === void 0 ? void 0 : isAuthorizeDashboard.module) === 'Dashboard') {
        if (isAuthorizeDashboard.submodule === 'Stockpile') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.stockpile;
        }
        else if (isAuthorizeDashboard.submodule === 'Silo') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.silo;
        }
        else if (isAuthorizeDashboard.submodule === 'Hopper') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.hopper;
        }
        else if (isAuthorizeDashboard.submodule === 'Coal Performance') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.contractorPerformance;
        }
        else if (isAuthorizeDashboard.submodule === 'Hauling Performance') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.haulingPerformance;
        }
        else if (isAuthorizeDashboard.submodule === 'Device Monitoring') {
            return constants_1.pathList.dashboard.path + subModuleDashboard.deviceManager;
        }
        else {
            return constants_1.pathList.dashboard.path;
        }
    }
    else if (isAuthorize.module === 'Stockpile') {
        return constants_1.pathList.posStockpile.path;
    }
    else if (isAuthorize.module === 'Silo') {
        return constants_1.pathList.posSilo.path;
    }
    else if (isAuthorize.module === 'Hopper') {
        return constants_1.pathList.posHopper.path;
    }
    else if (isAuthorize.module === 'BG. Loading Transshipment') {
        return constants_1.pathList.bgLoadingAndTranshipment.path;
    }
    else if (isAuthorize.module === 'CCTV Center') {
        return constants_1.pathList.cctv.path;
    }
    else if (isAuthorize.module === 'Daily Summary') {
        if (isAuthorize.submodule === 'Stockpile') {
            return constants_1.pathList.dailySummary.path + subModuleDailySummary.stockpile;
        }
        else if (isAuthorize.submodule === 'Silo') {
            return constants_1.pathList.dailySummary.path + subModuleDailySummary.silo;
        }
        else {
            return constants_1.pathList.dailySummary.path + subModuleDailySummary.hopper;
        }
    }
    else if (isAuthorize.module === 'User Access') {
        if (isAuthorize.submodule === 'User') {
            return constants_1.pathList.userAccess.path + subModuleUserAccess.user;
        }
        else {
            return constants_1.pathList.userAccess.path + subModuleUserAccess.roleMapping;
        }
    }
    else if (isAuthorize.module === 'Adjustment') {
        if (isAuthorize.submodule === 'Actual Production') {
            return constants_1.pathList.adjustment.path + subModuleAdjustment.stockpile;
        }
        else if (isAuthorize.submodule === 'Actual Hauling') {
            return constants_1.pathList.adjustment.path + subModuleAdjustment.silo;
        }
        else if (isAuthorize.submodule === 'Planning') {
            return constants_1.pathList.adjustment.path + subModuleAdjustment.planning;
        }
        else {
            return constants_1.pathList.adjustment.path + subModuleAdjustment.dayoff;
        }
    }
    else if (isAuthorize.module === 'Master Data') {
        if (isAuthorize.submodule === 'Contractor') {
            return constants_1.pathList.masterData.path + subModuleMasterData.contractor;
        }
        else if (isAuthorize.submodule === 'Pit') {
            return constants_1.pathList.masterData.path + subModuleMasterData.pit;
        }
        else if (isAuthorize.submodule === 'Area') {
            return constants_1.pathList.masterData.path + subModuleMasterData.area;
        }
        else if (isAuthorize.submodule === 'Seam') {
            return constants_1.pathList.masterData.path + subModuleMasterData.seam;
        }
        else if (isAuthorize.submodule === 'Coal Brand') {
            return constants_1.pathList.masterData.path + subModuleMasterData.brand;
        }
        else if (isAuthorize.submodule === 'Stockpile') {
            return constants_1.pathList.masterData.path + subModuleMasterData.stockpile;
        }
        else if (isAuthorize.submodule === 'Silo') {
            return constants_1.pathList.masterData.path + subModuleMasterData.silo;
        }
        else if (isAuthorize.submodule === 'Hopper') {
            return constants_1.pathList.masterData.path + subModuleMasterData.hopper;
        }
        else if (isAuthorize.submodule === 'Excavator') {
            return constants_1.pathList.masterData.path + subModuleMasterData.excavator;
        }
        else if (isAuthorize.submodule === 'Dump Truck') {
            return constants_1.pathList.masterData.path + subModuleMasterData.dtNumber;
        }
        else if (isAuthorize.submodule === 'Hauler') {
            return constants_1.pathList.masterData.path + subModuleMasterData.hauler;
        }
        else if (isAuthorize.submodule === 'Vessel') {
            return constants_1.pathList.masterData.path + subModuleMasterData.vessel;
        }
        else {
            return constants_1.pathList.masterData.path + subModuleMasterData.driver;
        }
    }
    else if (isAuthorize.module === 'Configuration') {
        if (isAuthorize.submodule === 'Pit Operation') {
            return constants_1.pathList.configuration.path + subModuleConfiguration.pitOperation;
        }
        else if (isAuthorize.submodule === 'Hauler') {
            return constants_1.pathList.configuration.path + subModuleConfiguration.haulerManager;
        }
        else if (isAuthorize.submodule === 'Stockpile') {
            return constants_1.pathList.configuration.path + subModuleConfiguration.stockpile;
        }
        else if (isAuthorize.submodule === 'Silo') {
            return constants_1.pathList.configuration.path + subModuleConfiguration.siloConfig;
        }
        else if (isAuthorize.submodule === 'Hopper') {
            return constants_1.pathList.configuration.path + subModuleConfiguration.hopperConfig;
        }
        else {
            return constants_1.pathList.configuration.path + subModuleConfiguration.rfidTag;
        }
    }
    else if (isAuthorize.module === 'Report') {
        if (isAuthorize.submodule === 'Production Data') {
            return constants_1.pathList.report.path + subModuleReport.production;
        }
        else if (isAuthorize.submodule === 'statistic') {
            return constants_1.pathList.report.path + subModuleReport.statistic;
        }
        else if (isAuthorize.submodule === 'Op. Attendance') {
            return constants_1.pathList.report.path + subModuleReport.attendance;
        }
        else if (isAuthorize.submodule === 'Pit Operation') {
            return constants_1.pathList.report.path + subModuleReport.pitOperation;
        }
        else if (isAuthorize.submodule === 'Hauling Operation') {
            return constants_1.pathList.report.path + subModuleReport.hauling;
        }
        else {
            return constants_1.pathList.report.path + subModuleReport.haulingStatistic;
        }
    }
    else if (isAuthorize.module === 'Coal Chain Simulation') {
        return constants_1.pathList.coalChainSimulationReport.path;
    }
    else {
        return '';
    }
};
exports.defaultRoutePath = defaultRoutePath;
const findDefaultAuth = (authorization, module) => {
    const submodule = module === 'Dashboard' ? 'Stockpile'
        : module === 'Stockpile' ? ''
            : module === 'Silo' ? ''
                : module === 'Hopper' ? ''
                    : module === 'BG. Loading Transshipment' ? ''
                        : module === 'CCTV Center' ? ''
                            : module === 'Daily Summary' ? 'Stockpile'
                                : module === 'User Access' ? 'User'
                                    : module === 'Adjustment' ? 'Stockpile'
                                        : module === 'Master Data' ? 'Contractor'
                                            : module === 'Configuration' ? 'Pit Operation'
                                                : module === 'Report' ? 'Production Data'
                                                    : module === 'Coal Chain Simulation' ? ''
                                                        : '';
    return authorization.filter(auth => auth.module === module &&
        auth.apps_type === 'Web' &&
        auth.submodule === submodule &&
        (auth.view || auth.change));
};
const defaultOpAccess = {
    id: '',
    user_id: '',
    has_access: false,
    checkpoint_id: '',
    checkpoint_type: '',
    checkpoint_name: '',
    checkpoint_type_id: '',
};
const operatorAccessStockpile = (operator_access) => {
    const operatorAccessPos1 = operator_access.find(item => item.checkpoint_name === 'POS 1');
    const operatorAccessPos2 = operator_access.find(item => item.checkpoint_name === 'POS 2');
    const operatorAccessPos3 = operator_access.find(item => item.checkpoint_name === 'POS 3');
    const operatorAccessPos4 = operator_access.find(item => item.checkpoint_name === 'POS 4');
    const operatorAccessPos5 = operator_access.find(item => item.checkpoint_name === 'POS 5');
    return {
        operatorAccessPos1: operatorAccessPos1
            ? Object.assign(Object.assign({}, operatorAccessPos1), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'POS 1' }),
        operatorAccessPos2: operatorAccessPos2
            ? Object.assign(Object.assign({}, operatorAccessPos2), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'POS 2' }),
        operatorAccessPos3: operatorAccessPos3
            ? Object.assign(Object.assign({}, operatorAccessPos3), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'POS 3' }),
        operatorAccessPos4: operatorAccessPos4
            ? Object.assign(Object.assign({}, operatorAccessPos4), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'POS 4' }),
        operatorAccessPos5: operatorAccessPos5
            ? Object.assign(Object.assign({}, operatorAccessPos5), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'POS 5' }),
    };
};
exports.operatorAccessStockpile = operatorAccessStockpile;
const operatorAccessSilo = (operator_access) => {
    const operatorAccessSilo1 = operator_access.find(item => item.checkpoint_name === 'Silo 1');
    const operatorAccessSilo2 = operator_access.find(item => item.checkpoint_name === 'Silo 2');
    const operatorAccessSilo3 = operator_access.find(item => item.checkpoint_name === 'Silo 3');
    const operatorAccessSilo4 = operator_access.find(item => item.checkpoint_name === 'Silo 4');
    return {
        operatorAccessSilo1: operatorAccessSilo1
            ? Object.assign(Object.assign({}, operatorAccessSilo1), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'Silo 1' }),
        operatorAccessSilo2: operatorAccessSilo2
            ? Object.assign(Object.assign({}, operatorAccessSilo2), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'Silo 2' }),
        operatorAccessSilo3: operatorAccessSilo3
            ? Object.assign(Object.assign({}, operatorAccessSilo3), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'Silo 3' }),
        operatorAccessSilo4: operatorAccessSilo4
            ? Object.assign(Object.assign({}, operatorAccessSilo4), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'Silo 4' })
    };
};
exports.operatorAccessSilo = operatorAccessSilo;
const operatorAccessHopper = (operator_access) => {
    const operatorAccessOld = operator_access.find(item => item.checkpoint_name === 'Old');
    const operatorAccessNew = operator_access.find(item => item.checkpoint_name === 'New');
    return {
        operatorHopperOld: operatorAccessOld
            ? Object.assign(Object.assign({}, operatorAccessOld), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'Old' }),
        operatorHopperNew: operatorAccessNew
            ? Object.assign(Object.assign({}, operatorAccessNew), { has_access: true }) : Object.assign(Object.assign({}, defaultOpAccess), { checkpoint_name: 'New' }),
    };
};
exports.operatorAccessHopper = operatorAccessHopper;
const userOperatorAccess = (operator_access, type) => {
    if (type === 'Stockpile') {
        return operator_access.filter(item => item.checkpoint_name.includes('POS'));
    }
    else if (type === 'Silo') {
        return operator_access.filter(item => item.checkpoint_name.includes('Silo'));
    }
    else {
        return operator_access.filter(item => item.checkpoint_name === 'Old' || item.checkpoint_name === 'New');
    }
};
exports.userOperatorAccess = userOperatorAccess;
const isUserExternal = (contractor_name) => {
    const excludeContractor = ['pt kideco jaya agung', 'pt xapiens teknologi indonesia'];
    return !excludeContractor.includes(contractor_name.toLowerCase()) ? true : false;
};
exports.isUserExternal = isUserExternal;
